export default __webpack_public_path__ + "static/media/icon-card-defects.dc75f479.svg";